export default __webpack_public_path__ + "static/media/CommonCity.7737474c.jpg";